import api, { buildQueryParams } from '../index';

export interface IClientRequirement {
  id: number;
  task_id: number;
  client_id: number;
  description: string;
  status: 'pending' | 'completed';
  created_at: string;
  updated_at: string;
}

export interface IRequirementFilters {
  task_id?: number;
  client_id?: number;
}

export const clientRequirementsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getClientRequirements: builder.query<
      IClientRequirement[],
      IRequirementFilters
    >({
      query: (params) =>
        `/client_requirements${buildQueryParams({ filters: params })}`,
      transformResponse: (response: {
        client_requirements: IClientRequirement[];
      }) => response.client_requirements,
    }),
    createClientRequirement: builder.mutation<
      IClientRequirement,
      { task_id: number; client_id: number; description: string }
    >({
      query: (body) => ({
        url: '/client_requirements',
        method: 'POST',
        body: { client_requirement: body },
      }),
      transformResponse: (response: {
        client_requirement: IClientRequirement;
      }) => response.client_requirement,
    }),
    updateClientRequirement: builder.mutation<
      IClientRequirement,
      {
        id: number;
        task_id?: number;
        client_id?: number;
        description?: string;
        status?: 'pending' | 'completed';
      }
    >({
      query: ({ id, ...client_requirement }) => ({
        url: `/client_requirements/${id}`,
        method: 'PUT',
        body: { client_requirement },
      }),
      transformResponse: (response: {
        client_requirement: IClientRequirement;
      }) => response.client_requirement,
    }),
    deleteClientRequirement: builder.mutation<any, number>({
      query: (id) => ({
        url: `/client_requirements/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetClientRequirementsQuery,
  useLazyGetClientRequirementsQuery,
  useCreateClientRequirementMutation,
  useUpdateClientRequirementMutation,
  useDeleteClientRequirementMutation,
} = clientRequirementsApi;
